export default __webpack_public_path__ + "static/media/404pagenotfound.2b5f9d4b.png";